// ----------------------------------------------------------------------

export default function Drawer(theme) {
  const INK = theme.palette.pixelInk;

  return {
    MuiDrawer: {
      styleOverrides: {
        modal: {
          '&[role="presentation"]': {
            '& .MuiDrawer-paperAnchorLeft': {
              borderRight: `2px solid ${INK}`,
              boxShadow: `8px 0px 0px 0px ${INK}`
            },
            '& .MuiDrawer-paperAnchorRight': {
              borderLeft: `2px solid ${INK}`,
              boxShadow: `-8px 0px 0px 0px ${INK}`
            }
          }
        }
      }
    }
  };
}
